import React from 'react';
import {Button, Checkbox, DatePicker, Form, Input, message, Modal, Pagination, Select, Table, Tabs} from "antd";
import Axios from "../../../utils/axios";
import Util from "../../../utils/utils";
import PATH_URL from "../../../utils/url";
import style from "../Content.module.css";
import OrderSummaryTab from "../achievement/OrderSummaryTab";

const qs = require('qs');
const TabPane = Tabs.TabPane;

class AchievementManageInfo extends React.Component {
    state = {
        loading: true,
        current: 1,
        pageSize: 10,
        total: 0,
        totalCompleted: 0,
        data: null,
        year: null,
        month: null,
        userName: null,
        realName: null,
        isExporting: false,
        selectedRowKeys: [],
        selected: [],
        checkboxText: '全选',
        isCheckAll: false,
        userPermission: null,
        roleList: [],
        rolePermission: [],
        achievementUserName: null,
        showAchievementModel: false,
        activeTab: 'total',
        avgLoading: false,
        avgData: null,
        avgUserName: null,
        avgRealName: null,
        avgRoleList: [],
        avgRolePermission: [],
        avgYear: null,
        avgMonth: null,
        avgStatus: null,
    }

    componentDidMount() {
        if (!Util.isEmpty(JSON.parse(window.sessionStorage.getItem("userName")))) {
            this.getUserPermission();
        }
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return
        }
    }

    getUserPermission = () => {
        Axios({
            method: 'get',
            url: PATH_URL.GET_USER_MENU_URL + "/" + JSON.parse(window.sessionStorage.getItem("userName")),
        }).then(res => {
            if (res.data.code === 200) {
                const perms = res.data.data;
                this.setState({
                    userPermission: perms,
                });
                const rolePermission = this.state.rolePermission;
                const avgRolePermission = this.state.avgRolePermission;
                if (perms !== null) {
                    if (perms.includes('300110')) {
                        rolePermission.push(1)
                    }
                    if (perms.includes('300111')) {
                        rolePermission.push(2)
                    }
                    if (perms.includes('300112')) {
                        rolePermission.push(5)
                    }
                    // 平均业绩独立角色权限
                    if (perms.includes('300136')) {
                        avgRolePermission.push(1)
                    }
                    if (perms.includes('300137')) {
                        avgRolePermission.push(2)
                    }
                    if (perms.includes('300138')) {
                        avgRolePermission.push(5)
                    }
                    // 默认tab指向有权访问的第一个tab，避免无权限tab导致空白
                    let activeTab = this.state.activeTab;
                    const canTotal = perms.includes('300133');
                    const canAvg = perms.includes('300134');
                    if (activeTab === 'total' && !canTotal && canAvg) {
                        activeTab = 'avg';
                    }
                    if (activeTab === 'avg' && !canAvg && canTotal) {
                        activeTab = 'total';
                    }
                    this.setState({
                        rolePermission: rolePermission,
                        avgRolePermission: avgRolePermission,
                        activeTab: activeTab,
                    })
                    this.initData();
                }
            } else {
                message.error(res.data.message);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    initData = () => {
        Axios({
            method: 'get',
            url: PATH_URL.LIST_TEAM_OR_OPERATOR_ACHIEVEMENT_URL,
            params: {
                userName: this.state.userName,
                realName: this.state.realName,
                year: this.state.year,
                month: this.state.month,
                roleList: this.state.roleList.length === 0 ? (this.state.rolePermission.length === 0 ? [-1] : this.state.rolePermission) : this.state.roleList,
                pageNum: this.state.current,
                pageSize: this.state.pageSize
            },
            paramsSerializer: function (params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            }
        }).then(res => {
            if (res.status === 200) {
                if (res.data.code === 200) {
                    let totalCompleted = 0;
                    if (res.data.data.list) {
                        res.data.data.list.forEach(item => {
                            totalCompleted += item.sumCompleted || 0;
                        });
                    }
                    this.setState({
                        data: res.data.data.list,
                        loading: false,
                        total: res.data.data.total,
                        totalCompleted: totalCompleted,
                    });
                } else {
                    this.setState({
                        loading: false,
                    });
                    message.error(res.data.message);
                }
            } else if (res.code === 401) {
                this.setState({
                    loading: false,
                });
                message.error(res.message);
            }
        }).catch(err => {
            this.setState({
                loading: false,
            });
            console.log(err);
        });
    }
    searchAchievement = () => {
        this.setState({
            loading: true
        })
        this.initData();
    }
    onDatePickerYearChange = (value, dateString) => {
        this.setState({
            year: dateString
        }, () => {
            this.searchAchievement();
        })
    }
    monthChange = (value) => {
        this.setState({
            month: value
        }, () => {
            this.searchAchievement();
        })
    }
    roleChange = (value) => {
        const roleList = [];
        roleList.push(value);
        this.setState({
            roleList: roleList,
        }, () => {
            this.searchAchievement();
        })
    }
    inputChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        }, () => {
            this.searchAchievement();
        });
    }
    resetSearch = () => {
        this.setState({
            year: null,
            month: null,
            userName: null,
            realName: null,
            roleList: [],
        })
    }
    // ===== 平均业绩 =====
    initAverageData = () => {
        this.setState({avgLoading: true});
        Axios({
            method: 'get',
            url: PATH_URL.LIST_AVERAGE_ACHIEVEMENT_URL,
            params: {
                userName: this.state.avgUserName,
                realName: this.state.avgRealName,
                roleList: this.state.avgRoleList.length === 0 ? (this.state.avgRolePermission.length === 0 ? [-1] : this.state.avgRolePermission) : this.state.avgRoleList,
                year: this.state.avgYear ? this.state.avgYear.format('YYYY') : null,
                month: this.state.avgMonth,
                status: this.state.avgStatus,
            },
            paramsSerializer: function (params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            }
        }).then(res => {
            if (res.status === 200) {
                if (res.data.code === 200) {
                    this.setState({
                        avgData: res.data.data,
                        avgLoading: false,
                    });
                } else {
                    this.setState({avgLoading: false});
                    message.error(res.data.message);
                }
            } else if (res.code === 401) {
                this.setState({avgLoading: false});
                message.error(res.message);
            }
        }).catch(err => {
            this.setState({avgLoading: false});
            console.log(err);
        });
    }
    avgInputChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        }, () => {
            this.initAverageData();
        });
    }
    avgRoleChange = (value) => {
        const roleList = [];
        roleList.push(value);
        this.setState({
            avgRoleList: roleList,
        }, () => {
            this.initAverageData();
        })
    }
    avgYearChange = (value, dateString) => {
        // 切换年度时清空月份，避免月份跨年度；value 为 moment 对象
        this.setState({
            avgYear: value || null,
            avgMonth: null,
        }, () => {
            this.initAverageData();
        })
    }
    avgMonthChange = (value) => {
        this.setState({
            avgMonth: value || null,
        }, () => {
            this.initAverageData();
        })
    }
    avgStatusChange = (value) => {
        this.setState({
            avgStatus: value === undefined ? null : value,
        }, () => {
            this.initAverageData();
        })
    }
    resetAvgSearch = () => {
        this.setState({
            avgUserName: null,
            avgRealName: null,
            avgRoleList: [],
            avgYear: null,
            avgMonth: null,
            avgStatus: null,
        }, () => {
            this.initAverageData();
        })
    }
    tabChange = (key) => {
        this.setState({
            activeTab: key,
        });
        if (key === 'avg' && this.state.avgData === null) {
            this.initAverageData();
        }
    }
    exportAchievementInfo = () => {
        if (this.state.selectedRowKeys.length === 0) {
            message.error("请选择要导出的数据!");
        } else {
            this.setState({
                loading: true,
                isExporting: true,
            })
            Axios({
                method: 'get',
                url: PATH_URL.EXPORT_ACHIEVEMENT_INFO_URL + "/" + this.state.selectedRowKeys,
                responseType: 'blob'
            }).then(res => {
                if (res.status === 200) {
                    const blob = new Blob([res.data])
                    const downloadElement = document.createElement('a');
                    const href = window.URL.createObjectURL(blob); //创建下载的链接
                    downloadElement.href = href;
                    downloadElement.download = '业绩数据.xlsx'; //下载后文件名
                    document.body.appendChild(downloadElement);
                    downloadElement.click(); //点击下载
                    document.body.removeChild(downloadElement); //下载完成移除元素
                    window.URL.revokeObjectURL(href); //释放掉blob对象
                    this.setState({
                        loading: false,
                        isExporting: false,
                    })
                } else if (res.code === 401) {
                    message.error(res.message);
                    this.setState({
                        loading: false,
                        isExporting: false,
                    })
                }
            }).catch(err => {
                console.log(err);
                this.setState({
                    loading: false,
                    isExporting: false,
                })
            });
        }
    }

    exportAllSelect = (e) => {
        this.setState({
            isCheckAll: e.target.checked,
        })
        if (e.target.checked) {
            Axios({
                method: 'get',
                url: PATH_URL.LIST_TEAM_OR_OPERATOR_ACHIEVEMENT_NO_PAGE_URL,
                params: {
                    userName: this.state.userName,
                    realName: this.state.realName,
                    roleList: this.state.roleList.length === 0 ? (this.state.rolePermission.length === 0 ? [-1] : this.state.rolePermission) : this.state.roleList,
                    year: this.state.year,
                    month: this.state.month,
                },
                paramsSerializer: function (params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                }
            }).then(res => {
                if (res.status === 200) {
                    if (res.data.code === 200) {
                        this.setState({
                            selectedRowKeys: res.data.data.sort(function (a, b) {
                                return a - b
                            }),
                            checkboxText: '取消全选',
                        });
                    } else {
                        this.setState({
                            loading: false,
                        });
                        message.error(res.data.message);
                    }
                } else if (res.code === 401) {
                    this.setState({
                        loading: false,
                    });
                    message.error(res.message);
                }
            }).catch(err => {
                this.setState({
                    loading: false,
                });
                console.log(err);
            });
        } else {
            const selected = this.state.selected;
            this.setState({
                selectedRowKeys: selected,
                checkboxText: '全选',
            });
        }
    }
    onSelectChange = (selectedRowKeys) => {
        const selected = this.state.selectedRowKeys;
        if (selectedRowKeys.length > 0) {
            selectedRowKeys.forEach(item => {
                if (selected.indexOf(item) < 0) {
                    selected.push(item);
                }
            });
        }
        this.setState({
            selected: selectedRowKeys.sort(function (a, b) {
                return a - b
            }),
            selectedRowKeys: selected.sort(function (a, b) {
                return a - b
            }),
        });
        if (this.state.selectedRowKeys.length === 0) {
            this.setState({
                isCheckAll: false,
                checkboxText: '全选',
            })
        }
    }
    rowOnSelect = (record, selected, selectedRows, nativeEvent) => {
        const selectedRowKeys = this.state.selectedRowKeys;
        if (selected === true) {
            selectedRowKeys.push(record.userName + "-" + record.date);
        } else {
            const index = selectedRowKeys.indexOf(record.userName + "-" + record.date);
            if (index >= 0) {
                selectedRowKeys.splice(index, 1);
            }
        }
        this.setState({
            selected: selectedRowKeys.sort(function (a, b) {
                return a - b
            }),
            selectedRowKeys: selectedRowKeys.sort(function (a, b) {
                return a - b
            }),
        });
    }
    onSelectAll = (selected, selectedRows, changeRows) => {
        if (!selected) {
            const selectedRowKeys = this.state.selectedRowKeys;
            for (let i = 0; i < changeRows.length; i++) {
                const index = selectedRowKeys.indexOf(changeRows[i].userName + "-" + changeRows[i].date);
                selectedRowKeys.splice(index, 1);
            }
            this.setState({
                selected: selectedRowKeys.sort(function (a, b) {
                    return a - b
                }),
                selectedRowKeys: selectedRowKeys.sort(function (a, b) {
                    return a - b
                }),
            });
        }
    }
    showAchievement = (record) => {
        this.setState({
            achievementUserName: record.userName,
            showAchievementModel: true,
        })
    }
    closeAchievementModel = () => {
        this.setState({
            showAchievementModel: false,
        })
    }

    render() {
        const columns = [
            {
                title: '账户',
                dataIndex: 'userName',
                key: 'userName',
            },
            {
                title: '姓名',
                dataIndex: 'realName',
                key: 'realName',
                render: (text, record) => {
                    if (record.role === 5) {
                        return <span>{text}<a onClick={this.showAchievement.bind(this, record)}> (详情)</a></span>
                    } else {
                        return text
                    }
                }
            },
            {
                title: '角色',
                dataIndex: 'role',
                key: 'role',
                render: role => {
                    switch (role) {
                        case 1:
                            return '线上电呼';
                        case 2:
                            return '业务团队';
                        case 5:
                            return '大客户';
                        default:
                            return '线上电呼';
                    }
                }
            },
            {
                title: '年度',
                dataIndex: 'year',
                key: 'year',
            },
            {
                title: '月份',
                dataIndex: 'month',
                key: 'month',
            },
            {
                title: '完成验车数',
                dataIndex: 'sumCompleted',
                key: 'sumCompleted',
            },
        ];

        // 平均业绩表格列
        const avgColumns = [
            {
                title: '姓名',
                dataIndex: 'realName',
                key: 'realName',
            },
            {
                title: '状态',
                dataIndex: 'status',
                key: 'status',
                render: status => {
                    switch (status) {
                        case 0:
                            return '启用中';
                        default:
                            return '已禁用';
                    }
                }
            },
            {
                title: '角色',
                dataIndex: 'role',
                key: 'role',
                render: role => {
                    switch (role) {
                        case 1:
                            return '线上电呼';
                        case 2:
                            return '业务团队';
                        case 5:
                            return '大客户';
                        default:
                            return '线上电呼';
                    }
                }
            },
            {
                title: '完成验车数',
                dataIndex: 'sumCompleted',
                key: 'sumCompleted',
            },
            {
                title: '工作总天数',
                dataIndex: 'workDays',
                key: 'workDays',
            },
            {
                title: '每日完成',
                dataIndex: 'dailyCompleted',
                key: 'dailyCompleted',
            },
        ];
        // 仅选择年度时，显示“当年月平均”列（当年完成总台次/有完成台次记录的月份数）
        if (this.state.avgYear) {
            avgColumns.push({
                title: '当年月平均',
                dataIndex: 'monthlyAvg',
                key: 'monthlyAvg',
            });
        }

        const rowSelection = {
            selectedRowKeys: [...this.state.selectedRowKeys],
            fixed: true,
            onChange: this.onSelectChange,
            onSelect: this.rowOnSelect,
            onSelectAll: this.onSelectAll,
        };
        return (
            <div className={style['content']} id='content'>
                <div className={style['content_info']}>
                    <Tabs activeKey={this.state.activeTab} onChange={this.tabChange}>
                        {this.state.userPermission != null && this.state.userPermission.includes('300133') ? (
                        <TabPane tab="总业绩统计" key="total">
                            <Form layout='inline'>
                                <Form.Item
                                    label="账户"
                                    name="userName"
                                    style={{width: 180}}>
                                    <Input placeholder="请输入账户"
                                           onChange={this.inputChange}/>
                                </Form.Item>
                                <Form.Item
                                    label="姓名"
                                    name="realName"
                                    style={{width: 200}}>
                                    <Input placeholder="请输入姓名"
                                           onChange={this.inputChange}/>
                                </Form.Item>
                                {this.state.userPermission != null && this.state.userPermission.includes('300109') ? (
                                    <Form.Item
                                        label="角色"
                                        name="role"
                                        style={{width: 150}}>
                                        <Select onChange={this.roleChange}
                                                allowClear>
                                            {
                                                this.state.userPermission.includes('300110') ? (
                                                    <Select.Option value="1">线上电呼</Select.Option>) : null
                                            }
                                            {
                                                this.state.userPermission.includes('300111') ? (
                                                    <Select.Option value="2">业务团队</Select.Option>) : null
                                            }
                                            {
                                                this.state.userPermission.includes('300112') ? (
                                                    <Select.Option value="5">大客户</Select.Option>) : null
                                            }
                                        </Select>
                                    </Form.Item>
                                ) : null}
                                <Form.Item
                                    label="年度"
                                    name="year"
                                    style={{width: 160}}>
                                    <DatePicker onChange={this.onDatePickerYearChange} picker="year"/>
                                </Form.Item>
                                <Form.Item
                                    label="月份"
                                    name="month"
                                    style={{width: 110}}>
                                    <Select onChange={this.monthChange}>
                                        <Select.Option value="01">1月</Select.Option>
                                        <Select.Option value="02">2月</Select.Option>
                                        <Select.Option value="03">3月</Select.Option>
                                        <Select.Option value="04">4月</Select.Option>
                                        <Select.Option value="05">5月</Select.Option>
                                        <Select.Option value="06">6月</Select.Option>
                                        <Select.Option value="07">7月</Select.Option>
                                        <Select.Option value="08">8月</Select.Option>
                                        <Select.Option value="09">9月</Select.Option>
                                        <Select.Option value="10">10月</Select.Option>
                                        <Select.Option value="11">11月</Select.Option>
                                        <Select.Option value="12">12月</Select.Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item>
                                    <Button type="primary" onClick={this.searchAchievement}>查询</Button>
                                    <Button type="primary" htmlType="reset" style={{'marginLeft': '10px'}}
                                            onClick={this.resetSearch}>重置</Button>
                                    {
                                        this.state.userPermission != null && this.state.userPermission.includes('300102') ? (
                                            <Button type="primary" htmlType="reset" style={{'marginLeft': '10px'}}
                                                    onClick={this.exportAchievementInfo}>导出</Button>) : null
                                    }
                                </Form.Item>
                            </Form>
                            <Table columns={columns}
                                   size="small"
                                   dataSource={this.state.data}
                                   rowKey={columns => (columns.userName + "-" + columns.date)}
                                   loading={this.state.loading}
                                   rowSelection={rowSelection}
                                   style={{'marginTop': '20px'}}
                                   pagination={false}/>
                            {/* 底部操作栏：全选 / 分页 / 当前页统计 一行显示；窗口过窄时整块换行，不裁切内容 */}
                            <div style={{
                                marginTop: 16,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                flexWrap: 'wrap',
                                columnGap: 16,
                                rowGap: 10,
                            }}>
                                <div style={{
                                    display: (this.state.data === null || this.state.data.length === 0) ? 'none' : 'flex',
                                    alignItems: 'center',
                                    flexShrink: 0,
                                }}>
                                    <Checkbox style={{fontSize: 12}} onChange={this.exportAllSelect}
                                              checked={this.state.isCheckAll}>{this.state.checkboxText}</Checkbox>
                                    <span style={{marginLeft: 8, fontSize: 12, color: '#606266', whiteSpace: 'nowrap'}}>
                                        已选 <b style={{color: '#1890ff'}}>{this.state.selectedRowKeys.length}</b> 条
                                    </span>
                                </div>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-end',
                                    flexWrap: 'wrap',
                                    columnGap: 16,
                                    rowGap: 8,
                                    minWidth: 0,
                                }}>
                                    <span style={{fontSize: 13, whiteSpace: 'nowrap'}}>
                                        当前页总完成验车数: <strong>{this.state.totalCompleted}</strong>
                                    </span>
                                    <Pagination
                                        showTotal={() => `共 ${this.state.total} 条`}
                                        showSizeChanger
                                        onShowSizeChange={(current, pageSize) => {
                                            this.setState({
                                                current: current,
                                                pageSize: pageSize
                                            });
                                            setTimeout(() => {
                                                this.initData();
                                            }, 100);
                                        }}
                                        total={this.state.total}
                                        current={this.state.current}
                                        pageSize={this.state.pageSize}
                                        onChange={(current, pageSize) => {
                                            this.setState({
                                                current: current,
                                                pageSize: pageSize
                                            });
                                            setTimeout(() => {
                                                this.initData();
                                            }, 100);
                                        }}/>
                                </div>
                            </div>
                        </TabPane>
                        ) : null}
                        {this.state.userPermission != null && this.state.userPermission.includes('300134') ? (
                        <TabPane tab="平均业绩" key="avg">
                            <Form layout='inline'>
                                <Form.Item
                                    label="账户"
                                    name="avgUserName"
                                    style={{width: 180}}>
                                    <Input placeholder="请输入账户"
                                           id="avgUserName"
                                           value={this.state.avgUserName}
                                           onChange={this.avgInputChange}/>
                                </Form.Item>
                                <Form.Item
                                    label="姓名"
                                    name="avgRealName"
                                    style={{width: 200}}>
                                    <Input placeholder="请输入姓名"
                                           id="avgRealName"
                                           value={this.state.avgRealName}
                                           onChange={this.avgInputChange}/>
                                </Form.Item>
                                {this.state.userPermission != null && this.state.userPermission.includes('300135') ? (
                                    <Form.Item
                                        label="角色"
                                        name="avgRole"
                                        style={{width: 150}}>
                                        <Select onChange={this.avgRoleChange}
                                                allowClear
                                                value={this.state.avgRoleList.length > 0 ? this.state.avgRoleList[0] : undefined}>
                                            {
                                                this.state.userPermission.includes('300136') ? (
                                                    <Select.Option value="1">线上电呼</Select.Option>) : null
                                            }
                                            {
                                                this.state.userPermission.includes('300137') ? (
                                                    <Select.Option value="2">业务团队</Select.Option>) : null
                                            }
                                            {
                                                this.state.userPermission.includes('300138') ? (
                                                    <Select.Option value="5">大客户</Select.Option>) : null
                                            }
                                        </Select>
                                    </Form.Item>
                                ) : null}
                                <Form.Item
                                    label="账号状态"
                                    name="avgStatus"
                                    style={{width: 150}}>
                                    <Select onChange={this.avgStatusChange}
                                            allowClear
                                            value={this.state.avgStatus}>
                                        <Select.Option value={0}>启用中</Select.Option>
                                        <Select.Option value={1}>已禁用</Select.Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    label="年度"
                                    name="avgYear"
                                    style={{width: 160}}>
                                    <DatePicker onChange={this.avgYearChange}
                                                picker="year"
                                                value={this.state.avgYear}/>
                                </Form.Item>
                                <Form.Item
                                    label="月份"
                                    name="avgMonth"
                                    style={{width: 110}}>
                                    <Select onChange={this.avgMonthChange}
                                            allowClear
                                            disabled={!this.state.avgYear}
                                            value={this.state.avgMonth}>
                                        <Select.Option value="01">1月</Select.Option>
                                        <Select.Option value="02">2月</Select.Option>
                                        <Select.Option value="03">3月</Select.Option>
                                        <Select.Option value="04">4月</Select.Option>
                                        <Select.Option value="05">5月</Select.Option>
                                        <Select.Option value="06">6月</Select.Option>
                                        <Select.Option value="07">7月</Select.Option>
                                        <Select.Option value="08">8月</Select.Option>
                                        <Select.Option value="09">9月</Select.Option>
                                        <Select.Option value="10">10月</Select.Option>
                                        <Select.Option value="11">11月</Select.Option>
                                        <Select.Option value="12">12月</Select.Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item>
                                    <Button type="primary" onClick={this.initAverageData}>查询</Button>
                                    <Button type="primary" htmlType="reset" style={{'marginLeft': '10px'}}
                                            onClick={this.resetAvgSearch}>重置</Button>
                                </Form.Item>
                            </Form>
                            <Table columns={avgColumns}
                                   size="small"
                                   dataSource={this.state.avgData}
                                   rowKey="userName"
                                   loading={this.state.avgLoading}
                                   style={{'marginTop': '20px'}}
                                   pagination={false}/>
                        </TabPane>
                        ) : null}
                    </Tabs>
                </div>
                <Modal
                    title={
                        <div
                            style={{
                                width: '100%',
                                cursor: 'move',
                            }}>
                            业绩汇总
                        </div>
                    }
                    visible={this.state.showAchievementModel}
                    onOk={this.closeAchievementModel}
                    onCancel={this.closeAchievementModel}
                    destroyOnClose={true}
                    width={1000}>
                    <OrderSummaryTab userName={this.state.achievementUserName}/>
                </Modal>
            </div>
        )
    }
}

export default AchievementManageInfo;